








import { Component, Vue, Prop } from "vue-property-decorator";
import AppPrompt from "@/components/AppPrompt.vue";
import request from "@/api/index";
import { IShareConfig, IShareConfigItem } from "@/api/types";
@Component({
  components: { AppPrompt }
})
export default class GraphicPage extends Vue {
  @Prop()
  appId!: string;
  time = 5;
  timer: any;
  request = new request();
  protected shareInfo: IShareConfigItem = {
    shareBg: "",
    shareLogo: "",
    appName: "",
    downloadUrl: "",
    shareClose: "",
    schemeUrl: ""
  };
  showBtn: any;
  mounted() {
    this.showBtn = true;
    if (ZWY_CLOUD.isOpenInApp() || this.appId == "1") {
      this.countDown();
    } else {
      console.log(this.$refs.returnBtn);
      let btn = document.getElementById("returnBtn") as HTMLDivElement;
      btn.setAttribute("class", "none");
    }
    this.getShareInfo(this.appId);
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.bottomBarConfig({
        isShowBottom: 0,
        callBack_replyList: "releaseReplyList",
        praiseNum: 0,
        isPraised: 0
      });
      ZWY_CLOUD.topBarConfig({
        isShowTop: 1,
        isShowBackBtn: 1,
        isShowTitle: "",
        isShowMoreBtn: "0"
      });
    } else {
      document.title = "该条信息不存在";
    }
  }
  // 倒计时
  countDown() {
    if (this.time > 0) {
      this.timer = setTimeout(() => {
        this.time -= 1;
        this.countDown();
      }, 1000);
    } else {
      this.stopCountDown();
    }
  }
  // 停止倒计时
  stopCountDown() {
    clearTimeout(this.timer);
    this.goback();
  }
  goback() {
    if (ZWY_CLOUD.isOpenInApp()) {
      ZWY_CLOUD.appCloseWeb({ type: 0 });
    } else if (this.appId == "1") {
      window.location.href = "http://m.cqnews.net/";
    }
  }
  getShareInfo(appId: string) {
    this.request.getShareInfoMethod(appId).then((response: IShareConfig) => {
      if (response.code >= 0) {
        this.shareInfo = response.data;
      }
    });
  }
}
